export default "__VITE_ASSET__BvIBi9ni__"